import Vue from 'vue'
import ElementUI from 'element-ui'
import elementLocale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, { locale: elementLocale })
